import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card shadow mx-0 mb-4 create-order-component animated fadeIn" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, [
    /*#__PURE__*/_createTextVNode(" Register Manual Order "),
    /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please provide the required information.")
  ])
], -1)
const _hoisted_3 = { class: "card-body text-center" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h4", {
  class: "mb-3",
  style: {"background-color":"#f8f9fa","padding":"12px","margin-bottom":"0","border-bottom":"1px solid #e9ecef"}
}, " Client Order ", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 text-left" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "form-group col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "pair-field" }, "Pair", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  value: "",
  selected: "selected"
}, " Please select ", -1)
const _hoisted_12 = { class: "form-group col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "side-field" }, "Side", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  value: "",
  selected: "selected"
}, " Please select ", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: "1" }, "BUY", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "2" }, "SELL", -1)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "amount-field" }, " Amount ", -1)
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = { class: "input-group-prepend" }
const _hoisted_21 = { class: "input-group-text" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "amount-field" }, "Unit Price", -1)
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "input-group-prepend" }
const _hoisted_26 = { class: "input-group-text" }
const _hoisted_27 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { for: "amount-field" }
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = { class: "input-group-prepend" }
const _hoisted_32 = { class: "input-group-text" }
const _hoisted_33 = { class: "form-group mt-5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "createAt" }, " Create At (optional) ", -1)
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = { class: "col-md-6 text-left px-3" }
const _hoisted_37 = {
  class: "card",
  style: {"font-size":"0.9rem"}
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Order summary ", -1)
const _hoisted_39 = { class: "card-body py-0" }
const _hoisted_40 = {
  class: "table text-left mb-0 details-table",
  style: {"margin-top":"10px"}
}
const _hoisted_41 = { class: "table-list-header" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Order Amount ")
const _hoisted_43 = {
  key: 0,
  class: "badge badge-pill badge-info target-badge little-pill"
}
const _hoisted_44 = { class: "table-list-value" }
const _hoisted_45 = { class: "table-list-header" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Order Total Price ")
const _hoisted_47 = {
  key: 0,
  class: "badge badge-pill badge-info target-badge little-pill"
}
const _hoisted_48 = { class: "table-list-value" }
const _hoisted_49 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, " CAD Reference Value ", -1)
const _hoisted_50 = { class: "table-list-value" }
const _hoisted_51 = { class: "d-flex justify-content-between" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fas fa-paste" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"1px"}
}, " Filling Orders Total Amount ", -1)
const _hoisted_54 = {
  class: "table-list-value",
  style: {"border-top-width":"1px"}
}
const _hoisted_55 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, " Filling Orders Total Price ", -1)
const _hoisted_56 = { class: "table-list-value" }
const _hoisted_57 = { class: "table-list-header" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Order Completion ")
const _hoisted_59 = {
  key: 0,
  class: "badge badge-pill badge-warning little-pill"
}
const _hoisted_60 = {
  key: 1,
  class: "badge badge-pill badge-warning little-pill"
}
const _hoisted_61 = {
  key: 2,
  class: "badge badge-pill badge-success little-pill"
}
const _hoisted_62 = { class: "table-list-value text-right" }
const _hoisted_63 = { colspan: "2" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", {
  class: "card-header",
  style: {"border-top":"1px solid #e3e6f0"}
}, " Revenues ", -1)
const _hoisted_65 = { class: "card-body py-0" }
const _hoisted_66 = {
  class: "table text-left mb-0 details-table",
  style: {"margin-top":"10px"}
}
const _hoisted_67 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Base Currency"),
  /*#__PURE__*/_createVNode("td", { class: "table-list-header text-right" }, " Quote Currency ")
], -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_69 = {
  key: 1,
  style: {"font-weight":"600"}
}
const _hoisted_70 = {
  key: 2,
  style: {"font-weight":"600"}
}
const _hoisted_71 = {
  key: 3,
  style: {"font-weight":"600"}
}
const _hoisted_72 = { class: "text-right" }
const _hoisted_73 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_74 = {
  key: 1,
  style: {"font-weight":"600"}
}
const _hoisted_75 = {
  key: 2,
  style: {"font-weight":"600"}
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "table-list-value text-left" }
const _hoisted_79 = { class: "table-list-value" }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "card-footer" }
const _hoisted_82 = { class: "container" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-md-12 d-flex justify-content-end" }
const _hoisted_85 = { class: "form-check mt-2" }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "notifyByEmail"
}, " Notify Customer ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_amountInput = _resolveComponent("amountInput")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pairId = $event)),
                  class: "form-control text-right",
                  id: "pair-field",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePair && _ctx.changePair(...args)))
                }, [
                  _hoisted_11,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pairs, (pair) => {
                    return (_openBlock(), _createBlock("option", {
                      key: pair.id,
                      value: pair.id
                    }, _toDisplayString(pair.baseCurrencyId) + " - " + _toDisplayString(pair.quoteCurrencyId), 9, ["value"]))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.pairId]
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.sideId = $event)),
                  class: "form-control text-right",
                  id: "side-field"
                }, [
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16
                ], 512), [
                  [_vModelSelect, _ctx.sideId]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.currentBaseCurrency?.id), 1)
                ]),
                _createVNode(_component_amountInput, {
                  disabled: !_ctx.pairId || !_ctx.sideId,
                  "onUpdate:amount": _cache[4] || (_cache[4] = ($event: any) => (_ctx.amount = $event)),
                  onInput: _ctx.changeAmount,
                  precision: _ctx.currentBaseCurrency?.exact
                }, null, 8, ["disabled", "onInput", "precision"])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.currentQuoteCurrency?.id), 1)
                ]),
                _createVNode("input", {
                  class: "form-control text-right",
                  type: "text",
                  value: _ctx.formatZeros(_ctx.getUnitPrice),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _hoisted_27
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("label", _hoisted_29, " Total Amount " + _toDisplayString(_ctx.currentQuoteCurrency?.id), 1),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, _toDisplayString(_ctx.currentQuoteCurrency?.id), 1)
                ]),
                _createVNode(_component_amountInput, {
                  modelValue: _ctx.total,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.total = $event)),
                  disabled: !_ctx.amount,
                  "onUpdate:amount": _cache[6] || (_cache[6] = ($event: any) => (_ctx.total = $event)),
                  precision: _ctx.currentQuoteCurrency?.exact
                }, null, 8, ["modelValue", "disabled", "precision"])
              ])
            ]),
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createVNode("input", {
                id: "createAt",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.createAt = $event)),
                type: "datetime-local",
                step: "1",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.createAt]
              ]),
              (_ctx.hasOrderCreateAtError && _ctx.createAt)
                ? (_openBlock(), _createBlock("small", _hoisted_35, " Invalid Date "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode("div", _hoisted_39, [
                _createVNode("table", _hoisted_40, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_41, [
                      _hoisted_42,
                      (_ctx.sideId == '1')
                        ? (_openBlock(), _createBlock("span", _hoisted_43, " TARGET "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", _hoisted_44, [
                      _createVNode("b", null, _toDisplayString(_ctx.currentBaseCurrency?.id || '' + ' '), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currentBaseCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.amount, 2)
                          : _ctx.formatZeros(_ctx.amount, _ctx.currentBaseCurrency?.exact)), 1)
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_45, [
                      _hoisted_46,
                      (_ctx.sideId == '2')
                        ? (_openBlock(), _createBlock("span", _hoisted_47, " TARGET "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", _hoisted_48, [
                      _createVNode("b", null, _toDisplayString(_ctx.currentQuoteCurrency?.id || '' + ' '), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.currentQuoteCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.total, 2)
                          : _ctx.formatZeros(_ctx.total, _ctx.currentQuoteCurrency?.exact)), 1)
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_49,
                    _createVNode("td", _hoisted_50, [
                      _createVNode("div", _hoisted_51, [
                        _withDirectives(_createVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.totalCostCad = _ctx.total)),
                          class: "btn btn-sm btn-info"
                        }, [
                          _hoisted_52
                        ], 512), [
                          [
                            _directive_tooltip,
                            'Paste Total Amount',
                            void 0,
                            { top: true }
                          ]
                        ]),
                        _createVNode(_component_amountInput, {
                          amount: _ctx.totalCostCad,
                          "onUpdate:amount": _cache[9] || (_cache[9] = ($event: any) => (_ctx.totalCostCad = $event)),
                          precision: 2
                        }, null, 8, ["amount"])
                      ])
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_53,
                    _createVNode("td", _hoisted_54, [
                      _createVNode("b", null, _toDisplayString(_ctx.currentBaseCurrency?.id || '' + ' '), 1),
                      _createTextVNode("   " + _toDisplayString(_ctx.currentBaseCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.totalAmount)
                          : _ctx.formatZeros(
                              _ctx.totalAmount,
                              _ctx.currentBaseCurrency?.exact
                            ) || 0), 1)
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_55,
                    _createVNode("td", _hoisted_56, [
                      _createVNode("b", null, _toDisplayString(_ctx.currentQuoteCurrency?.id || '' + ' '), 1),
                      _createTextVNode("   " + _toDisplayString(_ctx.currentQuoteCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.totalCost)
                          : _ctx.formatZeros(
                              _ctx.totalCost,
                              _ctx.currentQuoteCurrency?.exact
                            ) || 0), 1)
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_57, [
                      _hoisted_58,
                      (_ctx.progress == 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_59, "PENDING"))
                        : _createCommentVNode("", true),
                      (_ctx.progress > 0 && _ctx.progress < 100)
                        ? (_openBlock(), _createBlock("span", _hoisted_60, "PARTIALLY FILLED"))
                        : _createCommentVNode("", true),
                      (_ctx.progress >= 100)
                        ? (_openBlock(), _createBlock("span", _hoisted_61, "FILLED"))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", _hoisted_62, _toDisplayString(_ctx.progress) + "%", 1)
                  ]),
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_63, [
                      _createVNode(_component_ProgressBar, {
                        value: _ctx.progress,
                        showValue: false
                      }, null, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _hoisted_64,
              _createVNode("div", _hoisted_65, [
                _createVNode("table", _hoisted_66, [
                  _hoisted_67,
                  _createVNode("tr", null, [
                    _createVNode("td", null, [
                      (_ctx.currentPair && _ctx.getStatusCurrenciesSatstreet)
                        ? (_openBlock(), _createBlock(_component_icons_currency, {
                            cryptoCurrency: _ctx.ifCrypto(_ctx.currentPair.baseCurrencyId),
                            localCurrency: _ctx.ifLocal(_ctx.currentPair.baseCurrencyId),
                            width: '20',
                            height: '20',
                            key: _ctx.currentPair.baseCurrencyId
                          }, null, 8, ["cryptoCurrency", "localCurrency"]))
                        : _createCommentVNode("", true),
                      _hoisted_68,
                      (_ctx.currentBaseCurrency?.currencyType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_69, " $" + _toDisplayString(_ctx.formatPrice(_ctx.baseCurrencyRevenue)), 1))
                        : (_ctx.currentBaseCurrency?.currencyType === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_70, _toDisplayString(_ctx.formatZeros(
                            _ctx.baseCurrencyRevenue,
                            _ctx.currentBaseCurrency?.exact
                          )), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_71, " 0 "))
                    ]),
                    _createVNode("td", _hoisted_72, [
                      (_ctx.currentQuoteCurrency?.currencyType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_73, " $" + _toDisplayString(_ctx.formatPrice(_ctx.quoteCurrencyRevenue)), 1))
                        : (_ctx.currentQuoteCurrency?.currencyType === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_74, _toDisplayString(_ctx.formatZeros(
                            _ctx.quoteCurrencyRevenue,
                            _ctx.currentQuoteCurrency?.exact
                          )), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_75, " 0 ")),
                      _hoisted_76,
                      (_ctx.currentPair && _ctx.getStatusCurrenciesSatstreet)
                        ? (_openBlock(), _createBlock(_component_icons_currency, {
                            cryptoCurrency: _ctx.ifCrypto(_ctx.currentPair.quoteCurrencyId),
                            localCurrency: _ctx.ifLocal(_ctx.currentPair.quoteCurrencyId),
                            width: '20',
                            height: '20',
                            key: _ctx.currentPair.quoteCurrencyId
                          }, null, 8, ["cryptoCurrency", "localCurrency"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (
                      _ctx.providerOrders.length &&
                        _ctx.revenueBalance !== null &&
                        _ctx.revenueBalance[0] >= 0 &&
                        _ctx.revenueBalance[1] >= 0 &&
                        (_ctx.revenueBalance[0] > 0 || _ctx.revenueBalance[1] > 0)
                    )
                    ? (_openBlock(), _createBlock("tr", _hoisted_77, [
                        _createVNode("td", _hoisted_78, _toDisplayString(_ctx.providerOrders.length && _ctx.revenueBalance !== null
                          ? _ctx.revenueBalance[0]
                          : 0) + "% ", 1),
                        _createVNode("td", _hoisted_79, _toDisplayString(_ctx.providerOrders.length && _ctx.revenueBalance !== null
                          ? _ctx.revenueBalance[1]
                          : 0) + "% ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
                      _ctx.providerOrders.length &&
                        _ctx.revenueBalance !== null &&
                        _ctx.revenueBalance[0] >= 0 &&
                        _ctx.revenueBalance[1] >= 0 &&
                        (_ctx.revenueBalance[0] > 0 || _ctx.revenueBalance[1] > 0)
                    )
                    ? (_openBlock(), _createBlock("tr", _hoisted_80, [
                        _createVNode("td", {
                          colspan: "2",
                          class: ["percentage-distribution", {
                        inactive:
                          !_ctx.providerOrders.length || _ctx.revenueBalance == null
                      }]
                        }, [
                          _createVNode(_component_ProgressBar, {
                            value: _ctx.revenueBalanceForBar,
                            showValue: false
                          }, null, 8, ["value"])
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_81, [
      _createVNode("div", _hoisted_82, [
        _createVNode("div", _hoisted_83, [
          _createVNode("div", _hoisted_84, [
            _createVNode("div", _hoisted_85, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.notifyByEmail = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "notifyByEmail"
              }, null, 512), [
                [_vModelCheckbox, _ctx.notifyByEmail]
              ]),
              _hoisted_86
            ]),
            _createVNode("button", {
              disabled: 
                _ctx.canCreateOrder == false ||
                  _ctx.currentCreateOrderStatus == 'fetching'
              ,
              type: "button",
              class: "btn btn-primary ml-3",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.executeCreateOrder()))
            }, " Create Order ", 8, ["disabled"])
          ])
        ])
      ])
    ])
  ]))
}